import React from 'react'
import styled from 'styled-components'
import { OtherText } from 'styling/Typography'

export const Status = ({ status, objectColor }: { status: string, objectColor?: string }) => {
  return (
    <StatusWrapper status={status} objectColor={objectColor}>
      <section>
        <OtherText>{status}</OtherText>
      </section>
    </StatusWrapper>
  )
}

interface StatusWrapperProps {
  objectColor?: string
  status?: string
}

export const StatusWrapper = styled.div<StatusWrapperProps>`
  width: 85%;
  section {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 0.5rem;
    font-weight: 400;
    font-size: 0.75rem;
  }
  div {
    min-height: 0.5rem;
    height: 0.5rem;
   width: 0.5rem;
   min-width: 0.5rem;
    border-radius: 50%;
    background-color: ${({ status, objectColor }) =>
    objectColor ??
    ((status === 'Active' && `${props => props.theme.greenChart}`) ||
      (status === 'Pending order' && `${props => props.theme.greenChart}`) ||
      (status === 'In stock' && `${props => props.theme.blueChart}`) ||
      (status === 'On Vacation' && `${props => props.theme.blueChart}`) ||
      (status === 'Sick Relief' && `${props => props.theme.brownChart}`) ||
      (status === 'Not Working' && `${props => props.theme.redChart}`) ||
      (status === 'Inactive' && `${props => props.theme.redChart}`) ||
      (status === 'Out of Stock' && `${props => props.theme.redChart}`) ||
      (status === 'In Use' && `${props => props.theme.lightBlue}`))}
  }
`
